interface Props {
  activeColor: string;
}

const ClientEngagementIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="engagementGradient"
          x1="24"
          y1="20"
          x2="104"
          y2="108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B5CF6" />
          <stop offset="0.5" stopColor="#06B6D4" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>

        <linearGradient
          id="bubbleGradient"
          x1="34"
          y1="34"
          x2="92"
          y2="90"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A78BFA" />
          <stop offset="0.5" stopColor="#22D3EE" />
          <stop offset="1" stopColor="#4ADE80" />
        </linearGradient>

        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect x="12" y="12" width="104" height="104" rx="28" fill="#0B1220" />
      <rect
        x="12"
        y="12"
        width="104"
        height="104"
        rx="28"
        stroke="url(#engagementGradient)"
        strokeWidth="2"
        opacity="0.5"
      />

      <circle
        cx="64"
        cy="64"
        r="38"
        stroke="url(#engagementGradient)"
        strokeWidth="2"
        opacity="0.18"
      />

      <path
        d="M37 42C37 36.5 41.5 32 47 32H81C86.5 32 91 36.5 91 42V66C91 71.5 86.5 76 81 76H61L48 88V76H47C41.5 76 37 71.5 37 66V42Z"
        stroke="url(#bubbleGradient)"
        strokeWidth="4"
        strokeLinejoin="round"
        filter="url(#glow)"
      />

      <circle cx="53" cy="54" r="5" fill="#A78BFA" />
      <circle cx="75" cy="54" r="5" fill="#22D3EE" />

      <path
        d="M58 54H70"
        stroke="#E0F2FE"
        strokeWidth="3.5"
        strokeLinecap="round"
        filter="url(#glow)"
      />

      <circle cx="42" cy="92" r="4" fill="#67E8F9" />
      <circle cx="92" cy="88" r="4" fill="#4ADE80" />
      <circle cx="96" cy="42" r="4" fill="#A78BFA" />

      <path
        d="M46 84L53 76"
        stroke="#67E8F9"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M84 78L89 84"
        stroke="#4ADE80"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M91 46L86 49"
        stroke="#A78BFA"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ClientEngagementIcon;
